import { Navigate, Route, Routes } from 'react-router-dom';
import { BandeauSignature } from './components/index.js';
import { Connexion } from './pages/app/Connexion.js';
import { EvenementLayout } from './pages/app/EvenementLayout.js';
import { EvenementPage } from './pages/app/EvenementPage.js';
import { Hotes } from './pages/app/Hotes.js';
import { Evenements } from './pages/app/Evenements.js';
import { NouvelEvenement } from './pages/app/NouvelEvenement.js';
import { Participants } from './pages/app/Participants.js';
import { Repartition } from './pages/app/Repartition.js';
import { Planning } from './pages/app/Planning.js';
import { Diffusion } from './pages/app/Diffusion.js';
import { ApercuParcours } from './pages/app/ApercuParcours.js';
import { ParcoursPage } from './pages/public/Parcours.js';
import { Confirmation } from './pages/public/Confirmation.js';
import { Inscription } from './pages/public/Inscription.js';

function PageSimple({ titre, texte }: { titre: string; texte: string }) {
  return (
    <div className="page-mobile">
      <BandeauSignature />
      <div style={{ padding: '36px 20px' }} className="pile">
        <h1 className="display">{titre}</h1>
        <p className="texte-doux">{texte}</p>
      </div>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/i/:slug" element={<Inscription mode="inscription" />} />
      <Route path="/i/:slug/merci" element={<Confirmation />} />
      <Route path="/f/:token" element={<Inscription mode="modification" />} />
      <Route path="/f/:token/merci" element={<Confirmation />} />
      <Route path="/p/:token" element={<ParcoursPage />} />
      <Route path="/connexion" element={<Connexion />} />
      <Route path="/app" element={<Evenements />} />
      <Route path="/app/evenements/nouveau" element={<NouvelEvenement />} />
      <Route path="/app/e/:eventId" element={<EvenementLayout />}>
        <Route index element={<Navigate to="evenement" replace />} />
        <Route path="evenement" element={<EvenementPage />} />
        <Route path="participants" element={<Participants />} />
        <Route path="hotes" element={<Hotes />} />
        <Route path="repartition" element={<Repartition />} />
        <Route path="planning" element={<Planning />} />
        <Route path="diffusion" element={<Diffusion />} />
        <Route path="parcours/:householdId" element={<ApercuParcours />} />
      </Route>
      <Route path="/" element={<Navigate to="/connexion" replace />} />
      <Route path="*" element={<PageSimple titre="Page introuvable" texte="Vérifiez le lien reçu par e-mail." />} />
    </Routes>
  );
}
